var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07654 9.81934H19.5258L22.9413 20.272",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1413 18.1816H15.3708",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71851 3L7.10287 3.00001L8.99061 12.9676",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76453 19.2509C3.76453 20.0059 3.91323 20.7535 4.20214 21.451C4.49106 22.1485 4.91452 22.7823 5.44837 23.3161C5.98221 23.8499 6.61598 24.2734 7.31348 24.5623C8.01098 24.8512 8.75855 24.9999 9.51352 24.9999C10.2685 24.9999 11.0161 24.8512 11.7136 24.5623C12.4111 24.2734 13.0448 23.8499 13.5787 23.3161C14.1125 22.7823 14.536 22.1485 14.8249 21.451C15.1138 20.7535 15.2625 20.0059 15.2625 19.2509C15.2625 18.496 15.1138 17.7484 14.8249 17.0509C14.536 16.3534 14.1125 15.7196 13.5787 15.1858C13.0448 14.652 12.4111 14.2285 11.7136 13.9396C11.0161 13.6507 10.2685 13.502 9.51352 13.502C8.75855 13.502 8.01098 13.6507 7.31348 13.9396C6.61598 14.2285 5.98221 14.652 5.44837 15.1858C4.91452 15.7196 4.49106 16.3534 4.20214 17.0509C3.91323 17.7484 3.76453 18.496 3.76453 19.2509Z",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5338 22.9098C21.5338 23.4642 21.7541 23.9959 22.1461 24.3879C22.5381 24.78 23.0698 25.0002 23.6243 25.0002C24.1787 25.0002 24.7104 24.78 25.1024 24.3879C25.4945 23.9959 25.7147 23.4642 25.7147 22.9098C25.7147 22.3554 25.4945 21.8236 25.1024 21.4316C24.7104 21.0396 24.1787 20.8193 23.6243 20.8193C23.0698 20.8193 22.5381 21.0396 22.1461 21.4316C21.7541 21.8236 21.5338 22.3554 21.5338 22.9098Z",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabilities);
export default __webpack_public_path__ + "static/media/disabilities.c51ea8c8d3eb5fe67a323d2caa73f66e.svg";
export { ForwardRef as ReactComponent };